import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=244eb01b&scoped=true&"
import script from "./SettingsPanel.vue?vue&type=script&lang=js&"
export * from "./SettingsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244eb01b",
  null
  
)

export default component.exports